import { getClockwisePolygon } from "./index73.js";
import { SplitDirection } from "./index76.js";
import { SlicePolygon, Vectors, getByIndex, rayPolygonIntersection, smallestBBox } from "@project-rouge/rg-three";
import { Vector3 } from "three";
function SplitPolyByBBox(polygon, ratio, direction) {
	polygon = getClockwisePolygon(polygon);
	const bBox = smallestBBox(polygon);
	let line1 = bBox.maxSides[0];
	let line2 = bBox.maxSides[1];
	if (direction === SplitDirection.longitudinal) {
		line1 = bBox.minSides[0];
		line2 = bBox.minSides[1];
	}
	const vecPolygon = polygon.map((p) => new Vector3(...p));
	const p1 = pointAlongLine(line1.start, line1.end, ratio);
	const ray = {
		start: p1,
		dir: pointAlongLine(line2.start, line2.end, ratio).clone().sub(p1).normalize()
	};
	let count = 1;
	let delta = Infinity;
	const tolSquared = .1;
	const newRay = getAverageEdgeDir(vecPolygon, ray);
	while (delta > tolSquared) {
		if (count > 1e3) break;
		const { start: updateStart, dir: updateDir } = getAverageEdgeDir(vecPolygon, newRay);
		count++;
		newRay.start.multiplyScalar((count - 1) / count).addScaledVector(updateStart, 1 / count);
		newRay.dir.multiplyScalar((count - 1) / count).addScaledVector(updateDir, 1 / count);
		delta = newRay.start.distanceToSquared(updateStart);
	}
	return SlicePolygon({
		polygon: vecPolygon,
		ray: newRay
	});
}
function pointAlongLine(start, end, ratio = .5) {
	return start.clone().add(end.clone().sub(start.clone()).multiplyScalar(ratio));
}
function getAverageEdgeDir(polygon, ray) {
	const intersections = rayPolygonIntersection({
		polygon,
		ray
	});
	const averageDir = new Vector3();
	const averagePoint = new Vector3();
	for (const int of intersections) {
		const edgeEnd = getByIndex(polygon, int.index + 1);
		const edgeStart = getByIndex(polygon, int.index);
		const edgePerp = edgeEnd.clone().sub(edgeStart).normalize().cross(Vectors.Up);
		if (edgePerp.dot(ray.dir) < 0) edgePerp.negate();
		averageDir.add(edgePerp);
		averagePoint.add(int.point);
	}
	averageDir.normalize();
	averagePoint.multiplyScalar(1 / intersections.length);
	return {
		start: averagePoint,
		dir: averageDir
	};
}
export { SplitPolyByBBox };

//# sourceMappingURL=index77.js.map